import { createComponent } from 'js/lib/create-component'
import { trackPurchase } from 'js/lib/analytics'

createComponent('paymentTrackCompletion', function (stateJSON) {
  const stateData = JSON.parse(stateJSON)
  trackPurchase({
    transaction_id: stateData.transaction_id,
    affiliation: stateData.affiliation,
    currency: stateData.currency,
    value: stateData.value,
    frequency: stateData.frequency,
  })

  return {}
})
